import React from 'react';
import { H1, P } from '../atoms';
const ArticleTitle = ({ children, author, anonymous = false }) => React.createElement(React.Fragment, null,
    React.createElement(H1, null, children),
    author &&
        React.createElement(P, null,
            "By ",
            author),
    !author && anonymous &&
        React.createElement(P, null, "By Anonymous"));
export default ArticleTitle;
//# sourceMappingURL=ArticleTitle.js.map